import { render, staticRenderFns } from "./ApplicationsCoursesEditPage.vue?vue&type=template&id=15600f5d&scoped=true&"
import script from "./ApplicationsCoursesEditPage.vue?vue&type=script&lang=ts&"
export * from "./ApplicationsCoursesEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationsCoursesEditPage.vue?vue&type=style&index=0&id=15600f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15600f5d",
  null
  
)

export default component.exports